/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VipChatRouteImport } from './routes/vip-chat'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MerchSupportRouteImport } from './routes/merch-support'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as GiveawaysRouteImport } from './routes/giveaways'
import { Route as Fb4RouteImport } from './routes/fb4'
import { Route as Fb3RouteImport } from './routes/fb3'
import { Route as Fb2RouteImport } from './routes/fb2'
import { Route as Fb1RouteImport } from './routes/fb1'
import { Route as BecomeACreatorRouteImport } from './routes/become-a-creator'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MerchIndexRouteImport } from './routes/merch.index'
import { Route as VideoSlugRouteImport } from './routes/video.$slug'
import { Route as MerchProductHandleRouteImport } from './routes/merch.$productHandle'
import { Route as CreatorSlugRouteImport } from './routes/creator.$slug'
import { Route as AuthActionRouteImport } from './routes/auth/action'

const VipChatRoute = VipChatRouteImport.update({
  id: '/vip-chat',
  path: '/vip-chat',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchSupportRoute = MerchSupportRouteImport.update({
  id: '/merch-support',
  path: '/merch-support',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipRoute = MembershipRouteImport.update({
  id: '/membership',
  path: '/membership',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawaysRoute = GiveawaysRouteImport.update({
  id: '/giveaways',
  path: '/giveaways',
  getParentRoute: () => rootRouteImport,
} as any)
const Fb4Route = Fb4RouteImport.update({
  id: '/fb4',
  path: '/fb4',
  getParentRoute: () => rootRouteImport,
} as any)
const Fb3Route = Fb3RouteImport.update({
  id: '/fb3',
  path: '/fb3',
  getParentRoute: () => rootRouteImport,
} as any)
const Fb2Route = Fb2RouteImport.update({
  id: '/fb2',
  path: '/fb2',
  getParentRoute: () => rootRouteImport,
} as any)
const Fb1Route = Fb1RouteImport.update({
  id: '/fb1',
  path: '/fb1',
  getParentRoute: () => rootRouteImport,
} as any)
const BecomeACreatorRoute = BecomeACreatorRouteImport.update({
  id: '/become-a-creator',
  path: '/become-a-creator',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchIndexRoute = MerchIndexRouteImport.update({
  id: '/merch/',
  path: '/merch/',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoSlugRoute = VideoSlugRouteImport.update({
  id: '/video/$slug',
  path: '/video/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchProductHandleRoute = MerchProductHandleRouteImport.update({
  id: '/merch/$productHandle',
  path: '/merch/$productHandle',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorSlugRoute = CreatorSlugRouteImport.update({
  id: '/creator/$slug',
  path: '/creator/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/become-a-creator': typeof BecomeACreatorRoute
  '/fb1': typeof Fb1Route
  '/fb2': typeof Fb2Route
  '/fb3': typeof Fb3Route
  '/fb4': typeof Fb4Route
  '/giveaways': typeof GiveawaysRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/membership': typeof MembershipRoute
  '/merch-support': typeof MerchSupportRoute
  '/privacy': typeof PrivacyRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/vip-chat': typeof VipChatRoute
  '/auth/action': typeof AuthActionRoute
  '/creator/$slug': typeof CreatorSlugRoute
  '/merch/$productHandle': typeof MerchProductHandleRoute
  '/video/$slug': typeof VideoSlugRoute
  '/merch/': typeof MerchIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/become-a-creator': typeof BecomeACreatorRoute
  '/fb1': typeof Fb1Route
  '/fb2': typeof Fb2Route
  '/fb3': typeof Fb3Route
  '/fb4': typeof Fb4Route
  '/giveaways': typeof GiveawaysRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/membership': typeof MembershipRoute
  '/merch-support': typeof MerchSupportRoute
  '/privacy': typeof PrivacyRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/vip-chat': typeof VipChatRoute
  '/auth/action': typeof AuthActionRoute
  '/creator/$slug': typeof CreatorSlugRoute
  '/merch/$productHandle': typeof MerchProductHandleRoute
  '/video/$slug': typeof VideoSlugRoute
  '/merch': typeof MerchIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/become-a-creator': typeof BecomeACreatorRoute
  '/fb1': typeof Fb1Route
  '/fb2': typeof Fb2Route
  '/fb3': typeof Fb3Route
  '/fb4': typeof Fb4Route
  '/giveaways': typeof GiveawaysRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/membership': typeof MembershipRoute
  '/merch-support': typeof MerchSupportRoute
  '/privacy': typeof PrivacyRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/vip-chat': typeof VipChatRoute
  '/auth/action': typeof AuthActionRoute
  '/creator/$slug': typeof CreatorSlugRoute
  '/merch/$productHandle': typeof MerchProductHandleRoute
  '/video/$slug': typeof VideoSlugRoute
  '/merch/': typeof MerchIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/become-a-creator'
    | '/fb1'
    | '/fb2'
    | '/fb3'
    | '/fb4'
    | '/giveaways'
    | '/library'
    | '/login'
    | '/membership'
    | '/merch-support'
    | '/privacy'
    | '/signup'
    | '/support'
    | '/terms'
    | '/verify-email'
    | '/vip-chat'
    | '/auth/action'
    | '/creator/$slug'
    | '/merch/$productHandle'
    | '/video/$slug'
    | '/merch/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/become-a-creator'
    | '/fb1'
    | '/fb2'
    | '/fb3'
    | '/fb4'
    | '/giveaways'
    | '/library'
    | '/login'
    | '/membership'
    | '/merch-support'
    | '/privacy'
    | '/signup'
    | '/support'
    | '/terms'
    | '/verify-email'
    | '/vip-chat'
    | '/auth/action'
    | '/creator/$slug'
    | '/merch/$productHandle'
    | '/video/$slug'
    | '/merch'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/become-a-creator'
    | '/fb1'
    | '/fb2'
    | '/fb3'
    | '/fb4'
    | '/giveaways'
    | '/library'
    | '/login'
    | '/membership'
    | '/merch-support'
    | '/privacy'
    | '/signup'
    | '/support'
    | '/terms'
    | '/verify-email'
    | '/vip-chat'
    | '/auth/action'
    | '/creator/$slug'
    | '/merch/$productHandle'
    | '/video/$slug'
    | '/merch/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  BecomeACreatorRoute: typeof BecomeACreatorRoute
  Fb1Route: typeof Fb1Route
  Fb2Route: typeof Fb2Route
  Fb3Route: typeof Fb3Route
  Fb4Route: typeof Fb4Route
  GiveawaysRoute: typeof GiveawaysRoute
  LibraryRoute: typeof LibraryRoute
  LoginRoute: typeof LoginRoute
  MembershipRoute: typeof MembershipRoute
  MerchSupportRoute: typeof MerchSupportRoute
  PrivacyRoute: typeof PrivacyRoute
  SignupRoute: typeof SignupRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  VipChatRoute: typeof VipChatRoute
  AuthActionRoute: typeof AuthActionRoute
  CreatorSlugRoute: typeof CreatorSlugRoute
  MerchProductHandleRoute: typeof MerchProductHandleRoute
  VideoSlugRoute: typeof VideoSlugRoute
  MerchIndexRoute: typeof MerchIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vip-chat': {
      id: '/vip-chat'
      path: '/vip-chat'
      fullPath: '/vip-chat'
      preLoaderRoute: typeof VipChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merch-support': {
      id: '/merch-support'
      path: '/merch-support'
      fullPath: '/merch-support'
      preLoaderRoute: typeof MerchSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/membership': {
      id: '/membership'
      path: '/membership'
      fullPath: '/membership'
      preLoaderRoute: typeof MembershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaways': {
      id: '/giveaways'
      path: '/giveaways'
      fullPath: '/giveaways'
      preLoaderRoute: typeof GiveawaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fb4': {
      id: '/fb4'
      path: '/fb4'
      fullPath: '/fb4'
      preLoaderRoute: typeof Fb4RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fb3': {
      id: '/fb3'
      path: '/fb3'
      fullPath: '/fb3'
      preLoaderRoute: typeof Fb3RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fb2': {
      id: '/fb2'
      path: '/fb2'
      fullPath: '/fb2'
      preLoaderRoute: typeof Fb2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fb1': {
      id: '/fb1'
      path: '/fb1'
      fullPath: '/fb1'
      preLoaderRoute: typeof Fb1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/become-a-creator': {
      id: '/become-a-creator'
      path: '/become-a-creator'
      fullPath: '/become-a-creator'
      preLoaderRoute: typeof BecomeACreatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merch/': {
      id: '/merch/'
      path: '/merch'
      fullPath: '/merch/'
      preLoaderRoute: typeof MerchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video/$slug': {
      id: '/video/$slug'
      path: '/video/$slug'
      fullPath: '/video/$slug'
      preLoaderRoute: typeof VideoSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merch/$productHandle': {
      id: '/merch/$productHandle'
      path: '/merch/$productHandle'
      fullPath: '/merch/$productHandle'
      preLoaderRoute: typeof MerchProductHandleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator/$slug': {
      id: '/creator/$slug'
      path: '/creator/$slug'
      fullPath: '/creator/$slug'
      preLoaderRoute: typeof CreatorSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  BecomeACreatorRoute: BecomeACreatorRoute,
  Fb1Route: Fb1Route,
  Fb2Route: Fb2Route,
  Fb3Route: Fb3Route,
  Fb4Route: Fb4Route,
  GiveawaysRoute: GiveawaysRoute,
  LibraryRoute: LibraryRoute,
  LoginRoute: LoginRoute,
  MembershipRoute: MembershipRoute,
  MerchSupportRoute: MerchSupportRoute,
  PrivacyRoute: PrivacyRoute,
  SignupRoute: SignupRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  VipChatRoute: VipChatRoute,
  AuthActionRoute: AuthActionRoute,
  CreatorSlugRoute: CreatorSlugRoute,
  MerchProductHandleRoute: MerchProductHandleRoute,
  VideoSlugRoute: VideoSlugRoute,
  MerchIndexRoute: MerchIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
